module.exports = __webpack_public_path__ + "img/z (27).95655b56.png";